import React, { useState, useEffect } from 'react';
import { Grid, Fab } from '@mui/material';
import SwipeUpIcon from '@mui/icons-material/SwipeUp';

export const BtnSubir = () => {
    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 100) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <Grid
            container
            direction="row"
            className='ki-floating-action fade-in'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                sx={{ opacity: visible ? 1 : 0 }}>
            <Fab
                size="medium"
                color="primary"
                aria-label="Subir"

            >
                <SwipeUpIcon />
            </Fab>
        </Grid>
    );
};
